module.exports = __webpack_public_path__ + "static/media/sobre-bg.2ddb276f.jpg";